export const emptyOption = { value: "", label: "Seleccionar..." };

export const RecursosComercios = [
  "19",
  "SE",
  "SH",
  "PP",
  "2",
  "EP",
  "9",
  "SV",
  "LO",
  "SA",
  "DI",
  "IV"
];

export const RecursosComercio = [
  {
    description: "Obligaciones Fiscales",
    value: "19",
  },
  {
    description: "Tasa por Servicios Especiales de Limpieza e Higiene",
    value: "SE",
  },
  {
    description: "Tasa por Inspección de Seguridad e Higiene",
    value: "SH",
  },
  {
    description: "Derecho por Publicidad y Propaganda",
    value: "PP",
  },
  {
    description: "Derecho por Venta Ambulante",
    value: "2",
  },
  {
    description: "Derecho por Ocupación o Uso de Espacios Públicos",
    value: "EP",
  },
  {
    description: "Derechos por Explotación de Canteras, Canon por Extracción de Arena, Cascajo, Pedregullo, Canto Rodado, y Demás Sustancias Análogas en el Lecho de los Ríos",
    value: "9",
  },
  {
    description: "Tasa por Servicios Varios",
    value: "SV",
  },
  {
    description: "Derechos y Locaciones de Bienes y Servicios Municipales",
    value: "LO",
  },
  {
    description: "Tasa por Servicios Asistenciales",
    value: "SA",
  },
  {
    description: "Tasa por Servicios Indirectos y Directos Varios",
    value: "DI",
  },
  {
    description: "Derecho por uso de Infraestructura vial para accesos portuarios.",
    value: "IV"
  },
];